import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { message } from 'antd';
import Axios from 'axios';
import { debounce } from 'lodash-es';

import {
  setMenuSpot,
  setIsEnabledSilent,
  setCanBack,
  setDownloadVisible,
  setHotLenovoVisible,
  setOperationMenuVisible,
  setTopImgVideoVisible,
  setMaximize,
  setActiveMenu,
  setFirstRun,
} from '../actions/layout';
import { showAAppQRCode } from '../actions/adetail';
import { logPostInfo, logging } from '../actions/log';
import { setNetStatus, setInterfaceStatus } from '../actions/network';
import { updateIsVTEabled } from '../actions/asimstatus';
import NoNet from '../components/NoNet/NoNet';
import { CONTEXT } from '../config';
import { MENUS_CAN_BACK } from '../constants/layout';
import {
  cacheKeys,
  mySoftKeys,
  SCROLL_PAGE,
  welcomePopTime,
  Menu_Record,
} from '../constants/storageKeys';
import { PCStoreJsBridge } from '../nativeapi';
import About from './OperationMenu/About';
import DownloadManager from './DownloadManager';
import Setting from './OperationMenu/Setting';
import PhoneQRcode from './OperationMenu/PhoneQRcode';
import Menu from './Menu';
import Operation from './Operation';
import OperationMenu from './OperationMenu/OperationMenu';
import PinPop from './PinPop';
import PinPopClose from './PinPopClose';
import SIMPop from './SIMPop'; // 模拟器下载弹窗
import SimPopup from '../components/SimPopup/SimPopup'; // 模拟器是否下载选择弹窗
import InstDonePop from './InstDonePop';
import Search from './Search/Search';
import WpPreview from './WpPreview';
import Iframe from './Iframe';
import DetailCommentDialog from './DetailCommentDialog';
import CheckUpdate from './OperationMenu/CheckUpdate';
import {
  changeClass,
  getParamString,
  getParamString2,
  hasClass,
  logNative,
  getDefaultPage,
} from '../utils/utils';
import { SIM_PREPARING, SIM_STATUS_POP_SHOW } from '../constants/asimstatus';
import { updatePreviewInfo } from '../actions/wallpaper';
import { WP_DOWNLOAD_FINISHED, WP_DOWNLOAD_FAILED } from '../constants/wallpaper';
import success from '../static/msg-success.svg';
import fail from '../static/msg-fail.svg';
import ReleaseNotes from './OperationMenu/ReleaseNotes';
import UserFeedback from './OperationMenu/UserFeedback';
import TopImgVideo from './TopImgVideo';
import UserScore from './UserScore';
import Share from './OperationMenu/Share';
import FasterProduct from '../components/FasterProduct/FasterProduct';
import Message from './OperationMenu/Message';

import styles from './Layout.module.less';
import stylesLoading from '../components/Loading/Loading.module.less';
import Welcome from '../pages/Welcome/Welcome';
import { setIsSearchClick } from '../actions/search';

const selectCommandLine = createSelector(
  state => state.native,
  native => native.commandLine,
);

const selectNetStatus = createSelector(
  state => state.network,
  network => network.online,
);

const selectInTimeInstSoft = createSelector(
  state => state.layout,
  layout => layout.inTimeInstSoft,
);

const selectDownloadVisible = createSelector(
  state => state.layout,
  layout => layout.downloadVisible,
);

const selectOperationMenuVisible = createSelector(
  state => state.layout,
  layout => layout.OperationMenuVisible,
);

const selectAboutVisible = createSelector(
  state => state.layout,
  layout => layout.AboutVisible,
);

const selectPinPopVisible = createSelector(
  state => state.layout,
  layout => layout.pinPopVisible,
);

const selectPinPopCloseVisible = createSelector(
  state => state.layout,
  layout => layout.pinPopCloseVisible,
);

const selectCanBack = createSelector(
  state => state.layout,
  layout => layout.canback,
);

const selectDownloadPathVisible = createSelector(
  state => state.layout,
  layout => layout.downloadPathVisible,
);
// 独立包-检查更新
const selectCheckUpdate = createSelector(
  state => state.layout,
  layout => layout.checkUpdateVisible,
);

const selectPhoneVisible = createSelector(
  state => state.layout,
  layout => layout.phoneVisible,
);

const selectSIMStatus = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.status,
);
const selectSIMPopupInfo = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.SIMPopupInfo,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUninstallSoft = createSelector(
  state => state.native,
  native => native.uninstallSoft,
);

const selectDownloadSofts = createSelector(
  state => state.download,
  download => download.softs,
);

const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);

const selectWpPreview = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpPreviewInfo,
);

const selectDownloadImgs = createSelector(
  state => state.wallpaper,
  wallpaper => wallpaper.wpDowloadImgs,
);

const selectIframeInfo = createSelector(
  state => state.layout,
  layout => layout.iframeInfo,
);

const selectDetailCommentInfo = createSelector(
  state => state.layout,
  layout => layout.detailCommentInfo,
);

const selectReleaseNotesVisible = createSelector(
  state => state.layout,
  layout => layout.releaseNotesVisible,
);

const selectUserFeedbackVisible = createSelector(
  state => state.layout,
  layout => layout.userFeedbackVisible,
);

const selectTopImgVideoVisible = createSelector(
  state => state.layout,
  layout => layout.topImgVideo,
);

const selectShareVisible = createSelector(
  state => state.layout,
  layout => layout.shareVisible,
);

const selectFasterProductVisible = createSelector(
  state => state.layout,
  layout => layout.fasterProduct,
);

const selectIsMaximize = createSelector(
  state => state.layout,
  layout => layout.isMaximize,
);

const selectMessageVisible = createSelector(
  state => state.layout,
  layout => layout.messageVisible,
);

const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectWelcomeInit = createSelector(
  state => state.welcome,
  welcome => welcome.init,
);
const selectFirstRun = createSelector(
  state => state.layout,
  layout => layout.firstRun,
);

function Index({ children }) {
  const dispatch = useDispatch();
  const commandLine = useSelector(selectCommandLine);
  const history = useHistory();
  const location = useLocation();
  const containerRef = useRef(null);
  const imgVideoRef = useRef(null);

  const firstRun = useSelector(selectFirstRun);
  const inTimeInstSoft = useSelector(selectInTimeInstSoft);
  const downloadVisible = useSelector(selectDownloadVisible);
  const OperationMenuVisible = useSelector(selectOperationMenuVisible);
  const AboutVisible = useSelector(selectAboutVisible);
  const checkUpdateVisible = useSelector(selectCheckUpdate); // 独立包-检查更新
  const pinPopVisible = useSelector(selectPinPopVisible);
  const pinPopCloseVisible = useSelector(selectPinPopCloseVisible);
  const downloadPathVisible = useSelector(selectDownloadPathVisible);
  const phoneVisible = useSelector(selectPhoneVisible);
  const canBack = useSelector(selectCanBack);
  const logInfoData = useSelector(selectLogInfo);
  const SIMStatus = useSelector(selectSIMStatus); // 模拟器状态
  const uninstallSoft = useSelector(selectUninstallSoft); // 正处在卸载中的应用
  const downloadSoftDatas = useSelector(selectDownloadSofts); // 正处在下载安装中的应用
  const online = useSelector(selectNetStatus);
  const installedSoft = useSelector(selectInstalledSoft); // 本地应用
  const iframeInfo = useSelector(selectIframeInfo); // 展示iframe
  const detailCommentInfo = useSelector(selectDetailCommentInfo); // 展示弹框评论

  const wpPreview = useSelector(selectWpPreview); // 全屏预览壁纸
  // 正在处理中的壁纸
  const wpDowloadImgs = useSelector(selectDownloadImgs);

  const SIMPopupInfo = useSelector(selectSIMPopupInfo); //

  const releaseNotesVisible = useSelector(selectReleaseNotesVisible); // 更新日志
  const userFeedbackVisible = useSelector(selectUserFeedbackVisible); // 我要反馈
  const topImgVideo = useSelector(selectTopImgVideoVisible); // 头部图片视频
  const shareVisible = useSelector(selectShareVisible);
  const fasterProductVisible = useSelector(selectFasterProductVisible); // 加速器弹窗
  const isMaximize = useSelector(selectIsMaximize); // 是否全屏
  const messageVisible = useSelector(selectMessageVisible); // 消息中心

  const [userScoreVisible, setUserScoreVisible] = useState(false);

  const welcomeData = useSelector(selectWelcomeData);
  const welcomeInit = useSelector(selectWelcomeInit);
  const [welcome, setWelcome] = useState(false); // 判断欢迎页是否被弹出
  const [welcomeLoadImg, setWelcomeLoadImg] = useState(false); // 判断欢迎页是否被弹出
  const cachEL = useRef(null);

  /**
   * 初始化中的一些设置
   */
  useEffect(() => {
    // 初始化中 设置message时长
    message.config({ top: 315, duration: 2 });

    // 进入页面注册是否关闭快装功能
    const enabled = localStorage.getItem(cacheKeys.ENABLE_QUICK_INSTALL) || '1';
    const isEnabledSilent = enabled === '' || enabled === '1';
    dispatch(setIsEnabledSilent(isEnabledSilent));

    /**
     * 用户评分
     */
    setTimeout(() => {
      const userScore = localStorage.getItem(cacheKeys.USER_SCORE_VISIBLE);
      setUserScoreVisible(!userScore || userScore === '');
    }, 5 * 1000);
  });

  const setWallpaper = useCallback(
    param => {
      // 直接设置壁纸
      PCStoreJsBridge.wpSetWallpaper(param).then(ret2 => {
        if (ret2.succ === 'true') {
          message.success({
            content: '壁纸设置成功，请查看电脑桌面',
            className: wpPreview && wpPreview.isShow ? 'ant-message-notice-center' : '',
            icon: <img className="ant-message-custom-img" src={success} alt="success" />,
          });
          window.wpSettingWallpaperTaskList = window.wpSettingWallpaperTaskList.filter(
            item => param.id !== item.id,
          );
        } else {
          message.error({
            content: '设置失败，请稍后再试',
            icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
          });
        }
      });
    },
    [wpPreview],
  );

  /**
   * 壁纸下载任务管理
   * 下载任务完成之后的处理
   */
  useEffect(() => {
    wpDowloadImgs.forEach((wp, i) => {
      if (wp.status === WP_DOWNLOAD_FINISHED) {
        if (wp.type === 'wallpaper') {
          const param = { url: wp.wallpaperImg[2].uri, id: wp.wallpaperId };
          // 同时正在设置壁纸中的任务控制在三个以内
          if (!window.wpSettingWallpaperTaskList) {
            window.wpSettingWallpaperTaskList = [param];
            setWallpaper(param);
          } else if (
            window.wpSettingWallpaperTaskList &&
            window.wpSettingWallpaperTaskList.length < 3
          ) {
            const found = window.wpSettingWallpaperTaskList.find(wp => wp.id === param.id);
            if (!found) {
              window.wpSettingWallpaperTaskList.push(param);
              setWallpaper(param);
            }
          } else {
            message.error({
              content: '设置壁纸太频繁，请稍后再试',
              icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
            });
          }
        } else if (wp.type === 'preview') {
          // 预览壁纸
          PCStoreJsBridge.wpMaximizeStroe().then(ret => {
            if (ret.succ) {
              dispatch(
                updatePreviewInfo({
                  isShow: true,
                  url: wp.path,
                  wallpaper: wp,
                }),
              );
            }
          });
        }
      } else if (wp.status === WP_DOWNLOAD_FAILED) {
        message.error({
          content: '壁纸下载失败，请稍后再试',
          icon: <img className="ant-message-custom-img" src={fail} alt="success" />,
        });
      }
    });
  }, [wpDowloadImgs]);

  /**
   * 进入页面设置菜单是否展示小红点
   */
  useEffect(() => {
    const spotSoftStr = localStorage.getItem(mySoftKeys.RED_SPOT_SOFT) || '';
    const installedSpotSoft = installedSoft.find(
      softItem => softItem.androidType === '1' && spotSoftStr.indexOf(softItem.softID) > -1,
    );
    dispatch(setMenuSpot(installedSpotSoft && installedSpotSoft.softID));
  }, [dispatch, installedSoft]);

  // 移动窗口Mouse
  const handleWindowHtCaption = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    PCStoreJsBridge.startMoveWindow();
  }, []);
  // 移动窗口触屏
  const handleTouchStart = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    PCStoreJsBridge.touchStartWindow();
  }, []);

  const handleTouchMove = useCallback(ev => {
    PCStoreJsBridge.touchMoveWindow();
  }, []);

  const handleTouchEnd = useCallback(ev => {
    PCStoreJsBridge.touchEndWindow();
  }, []);

  const doubleClickTopBar = useCallback(
    e => {
      if (!window.PcstoreCanChangeSize) {
        return;
      }
      if (!hasClass(e.target, 'empty')) {
        return;
      }
      if (isMaximize) {
        dispatch(setMaximize({ isMaximize: false }));
        PCStoreJsBridge.middleWindow();
      } else {
        dispatch(setMaximize({ isMaximize: true }));
        PCStoreJsBridge.maximizeWindow();
      }
      sessionStorage.setItem('PCStoreIsMaximize', isMaximize ? 0 : 1);
      dispatch(
        logging({
          category: 'C',
          action: 'DbClick_Bar',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            isMaximize: isMaximize ? 0 : 1,
          },
        }),
      );
    },
    [isMaximize],
  );

  const handleHidden = useCallback(ev => {
    dispatch(showAAppQRCode(false));
    dispatch(setDownloadVisible(false));
    dispatch(setOperationMenuVisible(false));
    if (!(ev.target instanceof HTMLInputElement)) {
      dispatch(setHotLenovoVisible(-1));
    }
  }, []);

  useEffect(() => {
    const pn = location.pathname.replace(`${CONTEXT}`, '');
    let currentMenu = pn.split('/')[1];

    if (currentMenu === 'game') {
      currentMenu += `/${pn.split('/')[2] || ''}`;
    }

    if (MENUS_CAN_BACK.indexOf(currentMenu) > -1) {
      dispatch(setCanBack(false));
    } else {
      dispatch(setCanBack(true));
    }
  }, [location.pathname]);

  const handleBack = useCallback(() => {
    if (canBack) {
      history.goBack();
    }
    dispatch(
      logPostInfo({
        source_p: logInfoData.source || 'back',
        source_pp: logInfoData.source_p,
      }),
    );
  }, [canBack]);

  /**
   * 处理VT状态，并写入token
   */
  useEffect(() => {
    // 获取是否支持TV模式。由于此组件中的useEffect，最先执行，所以在这里调用，要先于在App.js调用
    PCStoreJsBridge.getIsVTEabled().then(vtObj => {
      dispatch(updateIsVTEabled({ isVTEabled: vtObj.vt === true }));
      // 一进入商店更新localStorage中的vt值
      localStorage.setItem(cacheKeys.IS_VT_ENABLE, vtObj.vt === true ? 1 : 0);
      // 为了确保打桩时：machineInfo，commandLine有值，所以延时上报桩
      setTimeout(() => {
        dispatch(
          logging({
            category: 'Simulate',
            action: 'VT_Status',
            label: '',
            param2: {
              status: vtObj.vt === true ? '1' : '0',
              vtstatus: vtObj.vtstatus,
            },
          }),
        );
      }, 2000);
    });
  }, [dispatch]);

  /**
   * 根据命令，处理需要跳入的页面
   */
  useEffect(() => {
    if (!commandLine || !firstRun) {
      return;
    }
    // 在这里控制FirstRun
    dispatch(setFirstRun(false));
    // 管家进入
    if (commandLine.indexOf('-c pcm_main') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/recommend`));
      history.replace(`${CONTEXT}/recommend`);
    }
    // 管家--工具箱--软件升级
    if (commandLine.indexOf('-c pcm_toolbox_update') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/update`));
      history.push(`${CONTEXT}/update`);
    }
    // 管家--工具箱--软件卸载
    if (commandLine.indexOf('-c pcm_toolbox_uninstall') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/uninstall`));
      history.push(`${CONTEXT}/uninstall`);
    }
    // 管家-软件升级弹窗
    if (commandLine.indexOf('-c pcm_tanchuang') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/update`));
      history.push(`${CONTEXT}/update`);
    }
    // 开机
    if (commandLine.indexOf('-c pcm_tanchuang_kaiji') > -1) {
      const softID = commandLine.split('#')[1];
      const bizInfo = JSON.stringify({});
      if (softID) {
        history.push(`${CONTEXT}/detail/soft/${softID}/${bizInfo}`);
      }
    }
    // 管家--垃圾清理--软件卸载
    if (commandLine.indexOf('-c pcm_clean_uninstall') > -1) {
      dispatch(setActiveMenu(`${CONTEXT}/uninstall`));
      history.replace(`${CONTEXT}/uninstall`);
    }
    // 管家直接进入详情页 并且触发下载
    if (commandLine && commandLine.indexOf('-c pcm_security_install') > -1) {
      logNative(`命令行：管家直接进入详情页 并且触发下载 commandLine=${commandLine}`);
      const softID = commandLine.split('#')[1] || '';
      const bizId = commandLine.split('#')[2] || '';
      if (softID || bizId) {
        const bizInfo = JSON.stringify({ bizType: 'intercept', bizId: bizId.split(' ')[0] });
        history.replace(`${CONTEXT}/detail/soft/${softID}/${bizInfo}?isDownload=1`);
      }
    }
    // 隐式启动商店，并开始下载软件
    if (commandLine && commandLine.indexOf('-c pcm_hidden_install') > -1) {
      logNative(`命令行：隐式启动商店，并开始下载软件 commandLine=${commandLine}`);
      const softIds = getParamString('softIds', commandLine);
      const pns = getParamString('pns', commandLine);
      const bizId = getParamString('bizId', commandLine);
      const bizType = getParamString('bizType', commandLine);
      let bizInfo = '{}';
      if (bizId && bizType) {
        bizInfo = JSON.stringify({ bizType, bizId });
      }

      // 只要有值就带上bizInfo
      // 默认地址
      const defaultPage = getDefaultPage();
      if (softIds || pns || bizId || bizType) {
        history.replace(`${defaultPage}?softIds=${softIds}&pns=${pns}&bizInfo=${bizInfo}`);
      } else {
        history.replace(`${defaultPage}`);
      }
    }

    // 调起商店，并跳入某个页面
    if (commandLine && commandLine.indexOf('-c open_page') > -1) {
      const pages = [
        'recommend',
        'education',
        'edurecommend',
        'educategory',
        'edumine',
        'edudetail',
        'work',
        'topn',
        'game',
        'shop',
        'update',
        'uninstall',
        'category',
        'detail',
        'search',
        'guesslikesmore',
        'topnmore',
        'androidrecommend',
        'androidcategory',
        'androiddetail',
        'special',
        'speciallist',
        'wpdetail',
        'wprecommend',
        'wpcategory',
        'wpmine',
        'wpzt',
        'wprank',
        'forumlist',
        'forumdetail',
        'otherpage',
      ];
      const page = getParamString('page', commandLine);
      logNative(`命令行：调起商店，并跳入某个页面 commandLine=${commandLine}`);
      if (page && pages.indexOf(page) > -1) {
        if (page === 'recommend') {
          const softIds = getParamString('softIds', commandLine);
          const pns = getParamString('pns', commandLine);
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          let bizInfo = '{}';
          if (bizId || bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }

          // 只要有值就带上bizInfo
          if (softIds || pns) {
            history.replace(`${CONTEXT}/${page}?softIds=${softIds}&pns=${pns}&bizInfo=${bizInfo}`);
          }
        } else if (page === 'category') {
          const code = getParamString('code', commandLine) || 'soft';
          const classId = getParamString('classId', commandLine) || '-1';
          const tagId = getParamString('tagId', commandLine) || '-1';
          history.push(`${CONTEXT}/${page}?code=${code}&classId=${classId}&tagId=${tagId}`);
        } else if (page === 'edurecommend') {
          history.push(`${CONTEXT}/education/recommend`);
        } else if (page === 'educategory') {
          const gradeId = getParamString('gradeId', commandLine) || '';
          const subjectId = getParamString('subjectId', commandLine) || '';
          const phaseId = getParamString('phaseId', commandLine) || '';
          history.push(
            `${CONTEXT}/education/category?gradeId=${gradeId}&subjectId=${subjectId}&phaseId=${phaseId}`,
          );
        } else if (page === 'edumine') {
          const tag = getParamString('tag', commandLine) || 'course';
          history.push(`${CONTEXT}/education/mine?tag=${tag}`);
        } else if (page === 'edudetail') {
          const courseId = getParamString('courseId', commandLine) || '';
          const studyState = getParamString('studyState', commandLine) || '0';
          const bizId = getParamString('bizId', commandLine) || '';
          const bizType = getParamString('bizType', commandLine) || '';
          history.push(
            `${CONTEXT}/edudetail?courseId=${courseId}&studyState=${studyState}&bizInfo=${{
              bizId,
              bizType,
            }}`,
          );
        } else if (page === 'search') {
          const keyword = getParamString('keyword', commandLine);
          history.push(`${CONTEXT}/${page}/soft?keyword=${keyword}`);
        } else if (page === 'game') {
          history.push(`${CONTEXT}/game`);
        } else if (page === 'topnmore') {
          const code = getParamString('code', commandLine);
          const title = getParamString('title', commandLine);
          history.push(`${CONTEXT}/${page}/${code}/${title}`);
        } else if (page === 'update') {
          const softIds = getParamString('softIds', commandLine);
          const pns = getParamString('pns', commandLine);
          const bizId = getParamString('bizId', commandLine) || '';
          const bizType = getParamString('bizType', commandLine) || '';
          history.push(
            `${CONTEXT}/${page}?softIds=${softIds}&pns=${pns}&bizId=${bizId}&bizType=${bizType}`,
          );
        } else if (page === 'detail') {
          const softID = getParamString('softId', commandLine);
          const isDownload = getParamString('isDownload', commandLine) || '0';
          const bizId = getParamString('bizId', commandLine) || '';
          const bizType = getParamString('bizType', commandLine) || '';
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId || bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(`${CONTEXT}/${page}/soft/${softID}/${bizInfo}?isDownload=${isDownload}`);
        } else if (page === 'androidrecommend') {
          history.push(`${CONTEXT}/android/recommend`);
        } else if (page === 'androidcategory') {
          const code = getParamString('code', commandLine) || 'soft';
          history.push(`${CONTEXT}/android/category?code=${code}`);
        } else if (page === 'androiddetail') {
          const pn = getParamString('pn', commandLine);
          const vc = getParamString('vc', commandLine) || 0;
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const isDownload = getParamString('isDownload', commandLine) || '0';
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId && bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(`${CONTEXT}/adetail/${pn}/${vc}/${bizInfo}?isDownload=${isDownload}`);
        } else if (page === 'special') {
          const ztId = getParamString('ztId', commandLine) || '1';
          const bannerId = 'outside';
          history.push(`${CONTEXT}/special?ztId=${ztId}&bannerId=${bannerId}`);
        } else if (page === 'speciallist') {
          history.push(`${CONTEXT}/speciallist`);
        } else if (page === 'wpdetail') {
          const wallpaperId = getParamString('wallpaperId', commandLine) || '1';
          const pageTage = getParamString('pageTage', commandLine) || 'collect';
          history.push(
            `${CONTEXT}/wpdetail?wallpaperId=${wallpaperId}&pageSource=screen&tagId=${pageTage}`,
          );
        } else if (page === 'wprecommend') {
          history.push(`${CONTEXT}/wprecommend`);
        } else if (page === 'wpcategory') {
          const classId = getParamString('classId', commandLine) || '-1';
          const tagId = getParamString('tagId', commandLine) || '-1';
          const colorId = getParamString('colorId', commandLine) || '-1';
          history.push(
            `${CONTEXT}/wpcategory/?classId=${classId}&tagId=${tagId}&colorId=${colorId}`,
          );
        } else if (page === 'wpmine') {
          const tagId = getParamString('tagId', commandLine) || 'collect';
          history.push(`${CONTEXT}/wpmine/${tagId}`);
        } else if (page === 'wpzt') {
          const wpZtId = getParamString('wpZtId', commandLine);
          history.push(`${CONTEXT}/wpzt?wpZtId=${wpZtId}`);
        } else if (page === 'wprank') {
          const code = getParamString('code', commandLine);
          history.push(`${CONTEXT}/wprank?code=${code}`);
        } else if (page === 'uninstall') {
          const lnkTarget = getParamString2('lnkTarget', commandLine) || '';
          const tag = getParamString2('tag', commandLine) || ''; // 'residual' || 'not_often_used_softs';
          history.push(`${CONTEXT}/uninstall?lnkTarget=${lnkTarget}&tag=${tag}`);
        } else if (page === 'otherpage') {
          const url = getParamString2('url', commandLine) || '';
          history.push(`${CONTEXT}/otherpage?url=${url}`);
        } else if (page === 'forumlist') {
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId && bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(`${CONTEXT}/forumlist?bizInfo=${bizInfo}`);
        } else if (page === 'forumdetail') {
          const id = getParamString('id', commandLine);
          const bizId = getParamString('bizId', commandLine);
          const bizType = getParamString('bizType', commandLine);
          const bizInfoStr = getParamString('bizInfo', commandLine) || '{}';
          let bizInfo = bizInfoStr;
          if (bizId && bizType) {
            bizInfo = JSON.stringify({ bizType, bizId });
          }
          history.push(`${CONTEXT}/forumdetail?id=${id}&bizInfo=${bizInfo}`);
        } else {
          const defaultPage = getDefaultPage();
          history.replace(defaultPage);
        }
      } else {
        const defaultPage = getDefaultPage();
        history.replace(defaultPage);
      }
    }
  }, [dispatch, commandLine, firstRun]);

  /**
   * 注册键盘事件, 打开另一个商店窗口
   * ctrl + alt + o + p
   */
  useEffect(() => {
    document.onkeydown = function(event) {
      const ev = event || window.event;
      if (ev.code === 'KeyO' && ev.ctrlKey && ev.shiftKey && ev.altKey) {
        PCStoreJsBridge.openOtherStore({
          width: '1060',
          height: '750',
          dbgUrlBar: true,
        });
      }
    };
  }, []);
  /**
   * 注册事件，让containerRef下的Dom重新渲染后滚动页面
   */
  useEffect(() => {
    if (containerRef && containerRef.current) {
      containerRef.current.addEventListener(
        'DOMNodeInserted',
        debounce(e => {
          scrollContainer(e);
        }, 20),
      );
    }
  }, [containerRef, history]);

  /**
   * 确保每次进入新的页面都是在顶部
   */
  useEffect(() => {
    if (history.action !== 'POP' && containerRef && containerRef.current) {
      containerRef.current.scrollTo(0, 0);
    }
  }, [history, window.location.pathname, containerRef]);

  /**
   * 拿取sessionStorage中的数据，并且滚动到相应的位置
   */
  const scrollContainer = useCallback(
    e => {
      // e.persist();
      if (containerRef && containerRef.current) {
        const scrollPageStr = sessionStorage.getItem(SCROLL_PAGE) || '{}';
        // const pageKey = `${location.pathname}${location.search}`;
        const pageKey = `${window.location.pathname}${window.location.search}`;
        const contDom = containerRef.current;

        try {
          const scrollPage = JSON.parse(scrollPageStr);
          const scrollPageTop = scrollPage[pageKey] || 0;
          const elCHeight = (contDom && contDom.firstChild && contDom.firstChild.scrollHeight) || 0;

          // 当子元素高度elCHeight-580(浏览器高度)>存储的滚动高度scrollPageTop
          // 且元素滚动高度elScrollTop !== 将要设置的高度时
          if (
            scrollPageTop !== null &&
            scrollPageTop !== parseInt(contDom.scrollTop) &&
            elCHeight > scrollPageTop &&
            history.action === 'POP' &&
            pageKey.indexOf('/recommend') === -1 &&
            pageKey.indexOf('/game') === -1 &&
            pageKey.indexOf('/category') === -1 &&
            pageKey.indexOf('/work') === -1 &&
            pageKey.indexOf('/game') === -1 &&
            pageKey.indexOf('/update') === -1 &&
            pageKey.indexOf('/uninstall') === -1 &&
            pageKey.indexOf('/wp') === -1 &&
            pageKey.indexOf('/speciallist') === -1 &&
            pageKey.indexOf('/education') === -1 &&
            pageKey.indexOf('/edudetail') === -1
          ) {
            logNative(`回退滚动页面到指定位置 `, {
              action: history.action,
              scrollPageTop,
              scrollTop: parseInt(contDom.scrollTop),
              elCHeight,
              pageKey,
            });
            contDom.scrollTo(0, scrollPageTop);
          }
          // 对卸载页面特殊处理
          if (history.action === 'POP' && pageKey.indexOf('/uninstall') > -1) {
            contDom.scrollTo(0, 0);
          }
        } catch (error) {
          logNative('Scroll Page JSON error', error);
        }
      }
    },
    [history, containerRef],
  );

  /**
   * sessionStorage.setItem(SCROLL_PAGE, {...}) 在滚动时记录滚动的位置
   * 在点击菜单时删掉保存的数据（请见Menu.js菜单点击事件handleActive方法）
   * 在点击搜索的时候，让滚动条滚动到顶部（请见：搜索、联想词、热词中的 handleSearch handleSelectKw方法）
   *
   */
  const onContainerScroll = useCallback(() => {
    if (containerRef && containerRef.current) {
      const contDom = containerRef.current;
      const scrollPageStr = sessionStorage.getItem(SCROLL_PAGE) || '{}';
      // const pageKey = `${location.pathname}${location.search}`;
      const pageKey = `${window.location.pathname}${window.location.search}`;
      const isLoading =
        document.getElementsByClassName(stylesLoading.loading).length > 0 &&
        document.getElementsByClassName(stylesLoading.loading_img).length > 0;
      try {
        if (contDom.scrollTop !== null && !isLoading) {
          const scrollPage = JSON.parse(scrollPageStr) || {};
          scrollPage[pageKey] = parseInt(contDom.scrollTop);
          sessionStorage.setItem(
            SCROLL_PAGE,
            JSON.stringify({
              ...scrollPage,
            }),
          );

          logNative(`记录滚动高度 `, {
            action: history.action,
            scrollTop: contDom.scrollTop,
            pageKey,
          });
        }
      } catch (error) {
        logNative(' 滚动页面失败 onContainerScroll', error);
      }
    }
  }, [history]);

  /**
   * 控制详情页面头部详情显示
   */
  const onContainerScrollForDetail = useCallback(
    e => {
      if (
        containerRef &&
        containerRef.current &&
        (history.location.pathname.indexOf(`${CONTEXT}/detail/soft`) > -1 ||
          history.location.pathname.indexOf(`${CONTEXT}/adetail`) > -1)
      ) {
        const moreDom = document.getElementById('soft_detail_more');
        const simpleDom = document.getElementById('soft_detail_simple');
        const menuDom = document.getElementById('soft_detail_menu');
        if (!moreDom || !simpleDom || !menuDom) {
          return;
        }
        const contDom = containerRef.current;
        let dist = moreDom.offsetHeight + 326; // 296 = 400 - 74 + 10(误差值)
        if (!topImgVideo || (topImgVideo && !topImgVideo.visible)) {
          dist = moreDom.offsetHeight; // 10 = 74 - 74 + 10(误差值)
        }
        if (dist - contDom.scrollTop <= 50) {
          simpleDom.style.display = 'flex';
          if (hasClass(moreDom, styles.detail_more_hide)) {
            changeClass(moreDom, styles.detail_more_hide, styles.detail_more_show);
          }
          changeClass(menuDom, styles.detail_hide, styles.detail_show);
          changeClass(simpleDom, styles.detail_show, styles.detail_hide);
        }
        if (dist - contDom.scrollTop > 50) {
          simpleDom.style.display = 'none';
          if (hasClass(moreDom, styles.detail_more_hide)) {
            changeClass(moreDom, styles.detail_more_show, styles.detail_more_hide);
          }
          changeClass(menuDom, styles.detail_show, styles.detail_hide);
          changeClass(simpleDom, styles.detail_hide, styles.detail_show);
        }
      }
    },
    [containerRef, history, topImgVideo],
  );

  /**
   * 控制详情页面头部视频显示
   */
  const onContainerScrollForImgVideo = useCallback(
    topImgVideo_ => {
      const detailContTopDist = 400; // 详情页面到顶部距离
      const specialImgHeight = 172; // 专题页面到顶部距离
      const topHeaderHeight = 74; // 头部距离
      let scrollDist = 60; // 滚动距离差值 默认值
      let beDist = 50; // 滚动距离差值, 在这个距离内忽略
      if (history && history.location && history.location.pathname) {
        if (
          history.location.pathname.indexOf(`${CONTEXT}/detail/soft`) > -1 ||
          history.location.pathname.indexOf(`${CONTEXT}/adetail`) > -1
        ) {
          beDist = 100; // 滚动距离差值, 在这个距离内忽略
          scrollDist = detailContTopDist - topHeaderHeight;
        }
        if (history.location.pathname.indexOf(`${CONTEXT}/special`) > -1) {
          scrollDist = specialImgHeight - topHeaderHeight;
        }
      }
      if (containerRef && containerRef.current && imgVideoRef && imgVideoRef.current) {
        const imgVideoDom = imgVideoRef.current;
        const contDom = containerRef.current;
        if (contDom.scrollTop < (scrollDist * 3) / 4) {
          const opacity = 1 - (1 * contDom.scrollTop) / ((scrollDist * 4) / 5);
          imgVideoDom.style.opacity = opacity;
          if (topImgVideo_ && topImgVideo_.isScrolled) {
            dispatch(setTopImgVideoVisible({ isScrolled: false }));
          }
        } else {
          imgVideoDom.style.opacity = 0;
          if (topImgVideo_ && !topImgVideo_.isScrolled) {
            dispatch(setTopImgVideoVisible({ isScrolled: true }));
          }
        }
      }
    },
    [dispatch, history],
  );

  useEffect(() => {
    if (
      history.action === 'POP' &&
      (history.location.pathname.indexOf(`${CONTEXT}/detail`) > -1 ||
        history.location.pathname.indexOf(`${CONTEXT}/adetail`) > -1 ||
        history.location.pathname.indexOf(`${CONTEXT}/special`) > -1)
    ) {
      onContainerScrollForImgVideo(topImgVideo);
    }
  }, [history, topImgVideo]);

  useEffect(() => {
    return () => {
      dispatch(setTopImgVideoVisible({ visible: false, isScrolled: false }));
    };
  }, []);

  // 判断是否为外部调起
  const skipOtherPage = () => {
    let skip = false;
    // 管家直接进入详情页 并且触发下载
    if (commandLine && commandLine.indexOf('-c pcm_security_install') > -1) {
      const softID = commandLine.split('#')[1] || '';
      const bizId = commandLine.split('#')[2] || '';
      if (softID || bizId) {
        skip = true;
      }
    }
    const params = [
      '-c pcm_toolbox_update',
      '-c pcm_toolbox_uninstall',
      '-c pcm_tanchuang',
      '-c pcm_clean_uninstall',
      '-c pcm_hidden_install',
    ];

    // 调起商店，并跳入某个页面
    if (commandLine && params.find(item => commandLine.indexOf(item) > -1)) {
      skip = true;
    }
    if (commandLine && commandLine.indexOf('-c open_page') > -1) {
      const page = getParamString('page', commandLine);
      const defaultPage = getDefaultPage();
      // 不为默认页面的时候，且目标页面也不是指向默认页面
      if (page !== '' && defaultPage.indexOf(page) === -1) {
        skip = true;
      }
    }
    return skip;
  };

  /**
   * 判断欢迎页是否已经被弹出
   */
  useEffect(() => {
    const HistoryLen = (history && history.length) || 0;
    // const nowTime = dayjs(+new Date()).format('YYYYMMDD');
    // const popTime = localStorage.getItem(welcomePopTime) || 0;
    // 首次·掉起商店跳入其他页面 不显示
    if (!commandLine || (HistoryLen < 2 && skipOtherPage())) {
      return;
    }
    // if (HistoryLen < 2 && nowTime - popTime) {
    if (HistoryLen < 2) {
      setWelcome(true);
    } else {
      setWelcome(false);
    }
  }, [commandLine]);

  useEffect(() => {
    if (welcomeData && welcomeData.tags) {
      let loaded = 0;
      welcomeData.tags.forEach((item, index) => {
        if (index < 4) {
          const imgs1 = new Image();
          imgs1.src = item.noSelectIcon;
          imgs1.onload = e => {
            loaded += 1;
            if (loaded >= 3) {
              setWelcomeLoadImg(true);
            }
          };
        }
      });
    }
  }, [welcomeData]);

  // 点击热搜框之外部分 弹窗消失 为缓存元素添加事件
  const hiddenHotSearch = () => {
    dispatch(setIsSearchClick(false));
    // 加了缓存之后click事件不能正确冒泡   所以这样手动监听点击事件
    dispatch(showAAppQRCode(false));
    dispatch(setDownloadVisible(false));
    dispatch(setOperationMenuVisible(false));
  };

  useEffect(() => {
    const target = document.getElementsByClassName('ka-wrapper');
    if (cachEL && cachEL.current) {
      cachEL.current.removeEventListener('click', hiddenHotSearch);
    }
    if (target && target[0]) {
      // eslint-disable-next-line prefer-destructuring
      cachEL.current = target[0];
      target[0].addEventListener('click', hiddenHotSearch);
    }
  }, [location]);

  return (
    <div
      className={`${styles.layout} ${styles.theme}`}
      onClick={handleHidden}
      onClickCapture={() => {
        dispatch(setIsSearchClick(false));
      }}
    >
      <div className="nav">
        <div className="nav-rgba" />
        <div
          className="logo"
          onMouseDown={handleWindowHtCaption}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        />
        <Menu />
      </div>
      <div className="main">
        {topImgVideo && topImgVideo.visible && topImgVideo.data && (
          <div className={`top_img_video`} ref={imgVideoRef}>
            <TopImgVideo />
          </div>
        )}
        <div
          className={`empty ${
            topImgVideo && topImgVideo.visible && !topImgVideo.isScrolled
              ? 'top_bar_white'
              : 'top_bar'
          }`}
          onMouseDown={handleWindowHtCaption}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onDoubleClick={doubleClickTopBar}
        >
          <span
            className={
              canBack ? 'back iconfont icon-opt_back canback' : 'back iconfont icon-opt_back gray'
            }
            onClick={handleBack}
          />
          <Search />
          <div className={'empty'} />
          <Operation />
          <div style={{ display: downloadVisible ? 'block' : 'none' }}>
            <DownloadManager />
          </div>
        </div>
        {/* 6.0 版本之前卸载页面不需要请求数据 {location.pathname.indexOf('uninstall') > -1 || online ? ( */}
        {online ? (
          <div
            className="content"
            id="container_content"
            ref={containerRef}
            onScroll={debounce(e => {
              onContainerScroll(e);
              onContainerScrollForImgVideo(topImgVideo);
              onContainerScrollForDetail(e);
            }, 20)}
          >
            {children}
          </div>
        ) : (
          <NoNet />
        )}
      </div>
      {AboutVisible && <About />}
      {OperationMenuVisible && <OperationMenu />}
      {pinPopVisible && <PinPop />}
      {pinPopCloseVisible && <PinPopClose />}
      {checkUpdateVisible && <CheckUpdate />}
      {/*
        模拟器等待提示弹框
        模拟器未启动点击卸载不弹出弹框（判断条件：1.卸载为空，2.或者卸载不为空并且有下载时弹出）
      */}
      {SIMStatus !== SIM_PREPARING &&
        SIM_STATUS_POP_SHOW.indexOf(SIMStatus) > -1 &&
        (uninstallSoft.length === 0 ||
          (uninstallSoft.length > 0 && downloadSoftDatas.length > 0)) && <SIMPop />}
      {SIMPopupInfo && <SimPopup />}
      {downloadPathVisible && <Setting />}
      {phoneVisible && <PhoneQRcode />}
      {inTimeInstSoft && inTimeInstSoft.appInfo && <InstDonePop />}
      {wpPreview && wpPreview.isShow && <WpPreview />}
      {iframeInfo && iframeInfo.visible && <Iframe />}
      {detailCommentInfo && detailCommentInfo.visible === true && <DetailCommentDialog />}
      {releaseNotesVisible && <ReleaseNotes />}
      {userFeedbackVisible && <UserFeedback />}
      {userScoreVisible &&
        +new Date() > +new Date('2021-03-8 14:00:00') &&
        +new Date() < +new Date('2021-04-11 14:00:00') && <UserScore />}
      {shareVisible && <Share />}
      {fasterProductVisible && <FasterProduct />}
      {messageVisible && <Message />}
      {welcome && welcomeData && welcomeData.needShow && !welcomeInit && welcomeLoadImg && (
        <Welcome />
      )}
    </div>
  );
}

export default memo(Index);
